(() => {
  const key = 'izz_order_cart_v1';
  const speedKey = 'izz_order_production_speed_v1';
  const attemptKey = 'izz_draft_attempt_shared_v2';
  let storageBlocked = false;
  const readSession = name => { try { return sessionStorage.getItem(name); } catch { storageBlocked = true; return null; } };
  const checkStorage = () => {
    try { const probe='izz_storage_probe'; localStorage.setItem(probe,'1'); localStorage.removeItem(probe); sessionStorage.getItem('izz_draft_attempt'); storageBlocked=false; return true; }
    catch { storageBlocked=true; return false; }
  };
  const read = () => {
    try {
      const items = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(items) ? items.filter(item => item && typeof item.key === 'string' && Number.isInteger(item.quantity) && item.quantity > 0 && Number.isInteger(item.lineCents) && item.lineCents >= 0).slice(0, 20) : [];
    } catch { storageBlocked = true; return []; }
  };
  const updateBadge = () => {
    const count = read().reduce((sum, item) => sum + item.quantity, 0);
    document.querySelectorAll('[data-order-cart-count]').forEach(el => { el.textContent = String(count + Number(el.dataset.nativeCount || 0)); });
  };
  const write = items => {
    localStorage.setItem(key, JSON.stringify(items));
    document.dispatchEvent(new Event('izz:order-cart'));
    updateBadge();
  };
  window.IzzOrderBasket = { read, write, replace(item, original) {
    const items = read(), index = items.findIndex(line => line.key === item.key);
    if (index < 0 || JSON.stringify(items[index]) !== original) throw new Error('This item changed in another tab or was removed. Return to your cart and edit it again.');
    items[index] = item;
    write(items);
  }, add(item) {
    const items = read();
    if (items.length >= 20) throw new Error(document.querySelector('[data-order-cart-limit]')?.dataset.orderCartLimit || 'Your cart is full. Submit this order before adding more items.');
    write([...items, item]);
  } };
  const submitted = readSession('izz_order_submission_pending');
  if (submitted && (document.querySelector('[data-order-success]') || new URL(location.href).searchParams.get('contact_posted') === 'true')) {
    try {
      const pending = JSON.parse(submitted);
      if (pending.receipt) localStorage.setItem('izz_order_last_receipt_v1', JSON.stringify(pending.receipt));
      const keys = Array.isArray(pending) ? pending : pending.keys;
      write(read().filter(item => !keys.includes(item.key)));
      sessionStorage.removeItem('izz_order_submission_pending');
      if (!read().length) localStorage.removeItem(speedKey);
    } catch { }
  }
  updateBadge();
  window.addEventListener('storage', updateBadge);
  document.addEventListener('izz:order-cart', updateBadge);
  class IzzOrderCart extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.strings = JSON.parse(this.querySelector('[data-order-strings]').textContent);
      checkStorage();
      this.list = this.querySelector('[data-order-items]');
      this.error = this.querySelector('[data-order-error]');
      this.form = this.querySelector('form');
      const success = this.querySelector('[data-order-success]');
      if (success) this.querySelector('[data-order-form]').before(success);
      this.nativeItems = [];
      this.renderBound = () => this.render();
      document.addEventListener('izz:order-cart', this.renderBound);
      this.storageBound = event => {
        if(event.key!==null&&![key,speedKey,attemptKey,'izz_order_last_receipt_v1'].includes(event.key))return;
        this.deliveryEstimate=null;this.estimateSequence=(this.estimateSequence||0)+1;
        if(this.submitting){this.storageChanged=true;return;}
        this.syncStoredSpeed();this.render();this.renderReceipt();
      };
      window.addEventListener('storage',this.storageBound);
      const speed = this.querySelector('[data-production-speed]');
      try { speed.value = localStorage.getItem(speedKey) === 'rush5' ? 'rush5' : 'standard'; } catch { }
      speed.addEventListener('change', () => {
        try { localStorage.setItem(speedKey, speed.value === 'rush5' ? 'rush5' : 'standard'); } catch { }
        this.render();
      });
      const setReceiptHidden = hidden => {
        this.receiptHidden = hidden;
        try {
          if (hidden) localStorage.setItem('izz_order_receipt_hidden_v1', this.receiptId || '');
          else localStorage.removeItem('izz_order_receipt_hidden_v1');
        } catch { }
        this.querySelector('[data-order-receipt]').hidden = hidden;
        this.querySelector('[data-receipt-show]').hidden = !hidden;
        this.querySelector('[data-receipt-details]').open = false;
        this.error.textContent = '';
      };
      this.querySelector('[data-receipt-hide]').addEventListener('click', () => {
        setReceiptHidden(true);
        this.querySelector('[data-receipt-show]').focus();
      });
      this.querySelector('[data-receipt-show]').addEventListener('click', () => {
        setReceiptHidden(false);
        this.querySelector('[data-receipt-hide]').focus();
      });
      this.querySelector('[data-receipt-new]').addEventListener('click', () => setReceiptHidden(true));
      this.renderReceipt();
      this.setupDelivery();
      this.setupCheckout();
      this.render();
      try {
        const response = await fetch(this.dataset.priceUrl);
        if (!response.ok) throw new Error();
        let data = await response.json();
        if (data.encoding === 'gzip-base64') {
          const bytes = Uint8Array.from(atob(data.payload), char => char.charCodeAt(0));
          data = await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))).json();
        }
        if (data.currency !== this.dataset.currency) throw new Error();
        this.prices = data;
        await this.readNativeCart();
        this.loaded = true;
      } catch { this.error.textContent = this.strings.loading_error; }
      this.render();
    }
    deliveryMethod() { return this.querySelector('[data-delivery]').value; }
    shippingAddress() { return Object.fromEntries([...this.querySelectorAll('[data-address]')].map(el=>[el.dataset.address,el.value.trim()])); }
    shippingFingerprint() { return JSON.stringify([read(),this.shippingAddress(),this.querySelector('[data-production-speed]').value,this.form.elements.namedItem('contact[email]').value.trim(),this.form.elements.namedItem('contact[name]').value.trim()]); }
    setupDelivery() {
      this.deliveryStrings=JSON.parse(this.querySelector('[data-delivery-strings]').textContent);
      const invalidate=()=>{this.deliveryEstimate=null;this.estimateSequence=(this.estimateSequence||0)+1;this.renderDelivery();};
      this.querySelector('[data-delivery]').addEventListener('change',()=>{invalidate();this.render();});
      this.querySelector('[data-shipping-address]').addEventListener('input',event=>{if(event.target.matches('[data-address]'))invalidate();});
      for(const name of ['contact[email]','contact[name]'])this.form.elements.namedItem(name).addEventListener('input',invalidate);
      this.querySelector('[data-estimate]').addEventListener('click',()=>this.updateShipping());
      this.querySelector('[data-shipping-rate]').addEventListener('change',event=>this.updateShipping(event.target.value));
    }
    renderDelivery() {
      const shipping=this.deliveryMethod()==='shipping',fields=this.querySelector('[data-shipping-address]'),meetup=this.form.elements.namedItem('izz_meetup_accept');
      fields.hidden=!shipping;fields.disabled=!shipping;meetup.required=!shipping;meetup.disabled=shipping;this.querySelector('[data-meetup-agreement]').hidden=shipping;
      if(this.deliveryEstimate&&this.estimateFingerprint!==this.shippingFingerprint()){this.deliveryEstimate=null;this.estimateSequence=(this.estimateSequence||0)+1;}
      const e=this.deliveryEstimate;
      this.querySelector('[data-delivery-cost]').textContent=shipping?(e?(e.shippingPending?this.deliveryStrings.pending:this.format(e.shippingCents)):this.deliveryStrings.needs_estimate):this.format(0);
      this.querySelector('[data-total-label]').textContent=shipping&&e?.shippingPending?this.deliveryStrings.total_pending:this.deliveryStrings.total;
      if(shipping){this.querySelector('[data-order-tax]').textContent=e?this.format(e.tax):'—';this.querySelector('[data-order-total]').textContent=e?this.format(e.total):'—';}
      this.querySelector('[data-rate-wrapper]').hidden=!shipping||!e?.rates.length;
      this.querySelector('[data-shipping-status]').textContent=e?(e.shippingPending?this.deliveryStrings.pending:this.deliveryStrings.estimated):this.deliveryStrings.needs_estimate;
      this.form.querySelector('[type="submit"]').disabled=Boolean(this.submitting)||!this.ready||!this.items?.length||(shipping&&!e);
    }
    async updateShipping(handle='') {
      if(this.deliveryMethod()!=='shipping'||!this.ready)return;
      const controls=[this.form.elements.namedItem('contact[name]'),this.form.elements.namedItem('contact[email]'),...this.querySelectorAll('[data-address]')];
      if(controls.some(el=>!el.reportValidity()))return;
      const fingerprint=this.shippingFingerprint(),sequence=(this.estimateSequence||0)+1;this.estimateSequence=sequence;this.deliveryEstimate=null;this.renderDelivery();
      const status=this.querySelector('[data-shipping-status]');status.textContent=this.deliveryStrings.estimating;
      try{
        const response=await fetch('/apps/izzraw-checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'estimate',deliveryMethod:'shipping',shippingAddress:this.shippingAddress(),shippingRateHandle:handle,items:read(),productionSpeed:this.querySelector('[data-production-speed]').value,email:controls[1].value.trim(),name:controls[0].value.trim(),notes:''})});
        const result=await response.json();
        if(sequence!==this.estimateSequence||fingerprint!==this.shippingFingerprint()||this.deliveryMethod()!=='shipping')return;
        if(!response.ok||result.estimated!==true)throw new Error(result.error||this.deliveryStrings.estimate_failed);
        this.deliveryEstimate=result;this.estimateFingerprint=fingerprint;
        const select=this.querySelector('[data-shipping-rate]');select.replaceChildren(...result.rates.map(rate=>{const option=this.node('option',rate.title+' — '+this.format(rate.cents));option.value=rate.handle;return option;}));select.value=result.selectedHandle;
        this.render();
      }catch(error){if(sequence===this.estimateSequence)status.textContent=error.message||this.deliveryStrings.estimate_failed;}
    }
    syncStoredSpeed() {
      try { this.querySelector('[data-production-speed]').value=localStorage.getItem(speedKey)==='rush5'?'rush5':'standard'; }
      catch { storageBlocked=true; }
    }
    async finishSubmission(result,attempt) {
      if(result.reference!=='IZZ-'+attempt.requestId||!Number.isSafeInteger(result.totalCents)||result.totalCents<0||!Number.isFinite(Date.parse(result.submittedAt)))throw new Error(this.strings.unconfirmed);
      const estimated=attempt.payload?.expectedTotalCents;
      const text=(attempt.receiptText||this.strings.request_heading)+'\n'+this.strings.confirmed_total+': '+this.format(result.totalCents)
        +(Number.isSafeInteger(estimated)&&estimated!==result.totalCents?'\n'+this.strings.total_adjustment+': '+this.format(result.totalCents-estimated):'')
        +'\n'+this.strings.submitted_note;
      const receipt={id:result.reference,submittedAt:result.submittedAt,deadline:this.cancellationDeadline(result.submittedAt),totalCents:result.totalCents,text};
      localStorage.setItem('izz_order_last_receipt_v1',JSON.stringify(receipt));
      const sent=attempt.payload?.items||[];
      window.IzzOrderBasket.write(read().filter(item=>!sent.some(line=>line.key===item.key&&JSON.stringify(line)===JSON.stringify(item))));
      if(!read().length)localStorage.removeItem(speedKey);
      sessionStorage.removeItem('izz_draft_attempt');
      localStorage.removeItem(attemptKey);
      this.renderReceipt();
      this.querySelector('[data-order-error]').textContent=this.strings.submitted_status.replace('{reference}',result.reference);
    }
    setupCheckout() {
      const cart=this,form=this.form;
      let busy=false;
      form.addEventListener('submit',async event=>{
        event.preventDefault();event.stopImmediatePropagation();
        if(busy||!cart.ready||!form.reportValidity())return;
        const error=cart.querySelector('[data-order-error]');
        if(!checkStorage()){cart.render();return;}
        if(!navigator.locks?.request){error.textContent=cart.strings.browser_required;return;}
        busy=true;cart.submitting=true;cart.renderDelivery();
        let confirmedReference='';
        try {
          await navigator.locks.request('izz-checkout-submit',async()=>{
            cart.syncStoredSpeed();cart.render();
            if(!cart.ready)return;
            if(cart.nativeItems?.length){error.textContent='Please customize every item before submitting.';return;}
            const value=name=>form.elements.namedItem(name)?.value?.trim()||'';
            const checked=name=>form.elements.namedItem(name)?.checked===true;
            if(cart.deliveryMethod()==='pickup'&&!checked('izz_meetup_accept')){error.textContent='Confirm pickup at Colton Post Office before submitting.';return;}
            const items=read();if(!items.length)return;
            const payload={items,email:value('contact[email]'),name:value('contact[name]'),notes:value('contact[Order notes]'),policyAccepted:checked('contact[Order policy agreement]'),meetupAccepted:checked('izz_meetup_accept'),deliveryMethod:cart.deliveryMethod(),shippingAddress:cart.shippingAddress(),shippingRateHandle:cart.deliveryEstimate?.selectedHandle||'',shippingPending:cart.deliveryEstimate?.shippingPending===true,productionSpeed:cart.querySelector('[data-production-speed]').value,expectedTotalCents:cart.deliveryMethod()==='shipping'?cart.deliveryEstimate?.total:cart.subtotal+cart.rushFee+cart.tax};
            if(cart.deliveryMethod()==='shipping'&&(!cart.deliveryEstimate||cart.estimateFingerprint!==cart.shippingFingerprint())){error.textContent=cart.deliveryStrings.invalid_estimate;return;}
            const fingerprint=JSON.stringify(payload);
            let attempt=JSON.parse(localStorage.getItem(attemptKey)||'null');
            if(!attempt){
              const legacy=JSON.parse(sessionStorage.getItem('izz_draft_attempt')||'null');
              if(legacy){attempt={...legacy,payload:JSON.parse(legacy.fingerprint)};localStorage.setItem(attemptKey,JSON.stringify(attempt));}
            }
            if(attempt&&!/^[a-f0-9-]{36}$/.test(attempt.requestId||''))throw new Error(cart.strings.unconfirmed);
            if(attempt&&attempt.fingerprint!==fingerprint){
              const response=await fetch('/apps/izzraw-checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'status',requestId:attempt.requestId})});
              const status=await response.json();
              if(response.ok&&status.submitted===true){
                confirmedReference='IZZ-'+attempt.requestId;
                await cart.finishSubmission(status,attempt);return;
              }
              if(!response.ok||status.retryable!==true)throw new Error(status.error||cart.strings.unresolved.replace('{reference}','IZZ-'+attempt.requestId));
            }
            const requestId=attempt?.requestId||crypto.randomUUID();
            cart.requestId='IZZ-'+requestId;cart.submittedAt=new Date().toISOString();cart.buildRequest();
            attempt={requestId,fingerprint,payload,receiptText:cart.querySelector('[data-order-body]').value+'\nOrder notes: '+payload.notes};
            localStorage.setItem(attemptKey,JSON.stringify(attempt));
            error.textContent='Submitting your order for review…';
            const response=await fetch('/apps/izzraw-checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...payload,requestId})});
            const result=await response.json();
            if(!response.ok||result.submitted!==true||result.reference!=='IZZ-'+requestId)throw new Error(result.error||cart.strings.unresolved.replace('{reference}','IZZ-'+requestId));
            confirmedReference=result.reference;
            await cart.finishSubmission(result,attempt);
          });
        } catch(e) {
          error.textContent=confirmedReference?cart.strings.receipt_failed.replace('{reference}',confirmedReference):(e.message||cart.strings.unconfirmed);
        } finally {
          busy=false;cart.submitting=false;
          if(cart.storageChanged){
            const message=error.textContent;cart.storageChanged=false;cart.syncStoredSpeed();cart.render();error.textContent=message;
          }
          cart.renderDelivery();
        }
      },true);
    }
    async readNativeCart() {
      const response = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error();
      const cart = await response.json();
      this.nativeItems = cart.items.filter(item => !item.properties?.['_Artwork reference']).map(item => ({
        key: 'native:' + item.key, nativeKey: item.key, productTitle: item.product_title, quantity: item.quantity,
        lineCents: item.final_line_price, unitCents: item.final_price, native: true,
        properties: item.properties || {}, size: item.options_with_values?.find(option => option.name === 'Size')?.value || '',
        printSetup: item.options_with_values?.find(option => option.name === 'Print Setup')?.value || '',
        method: item.properties?.Decoration || item.variant_title, color: item.properties?.['Shirt color'] || item.properties?.['Preferred color'] || '',
        artwork: { primary: item.properties?.Artwork || item.properties?.['Artwork link'] || '', back: item.properties?.['Back artwork'] || item.properties?.['Back artwork link'] || '', side: item.properties?.['Side artwork'] || item.properties?.['Side artwork link'] || '' }
      }));
      document.querySelectorAll('[data-order-cart-count]').forEach(el => { el.dataset.nativeCount = String(cart.item_count); });
      updateBadge();
    }
    decode(value) {
      if (typeof value !== 'string') return value;
      let total = 0;
      return value.split(',').map(delta => (total += parseInt(delta, 36)));
    }
    price(item, quantity) {
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > this.prices.maxQuantity) return null;
      if (['hat', 'bag'].includes(item.kind)) {
        const group = this.prices.accessories[item.kind];
        group[item.method] = this.decode(group[item.method]);
        const total = group[item.method]?.[quantity - 1];
        return Number.isInteger(total) ? total + (item.sideEnabled ? 500 * quantity : 0) : null;
      }
      const product = this.prices.products[item.shirtType || this.prices.defaultProducts[item.kind]];
      const group = Object.values(product?.groups || {}).find(value => value.sizes.includes(item.size));
      if (!group) return null;
      if (item.method === 'screen') {
        const colors = item.inkColors;
        const key = item.hasFront && item.hasBack ? `${colors}-${colors}` : `${colors}-0`;
        group.screen[key] = this.decode(group.screen[key]);
        return group.screen[key]?.[quantity - 1] ?? null;
      }
      group.dtfTotals[item.printSetup] = this.decode(group.dtfTotals[item.printSetup]);
      return group.dtfTotals[item.printSetup]?.[quantity - 1] ?? null;
    }
    groupKey(item) {
      if (!['tee', 'hoodie'].includes(item.kind)) return item.key;
      const art = item.artworkIdentity || item.artwork || {};
      if (!(art.primary || art.back)) return item.key;
      const details = Object.entries(item.properties || {}).filter(([name]) => /placement|notes|ink|design/i.test(name)).sort(([a], [b]) => a.localeCompare(b));
      return JSON.stringify([item.kind, item.shirtType, item.method, item.printSetup, item.inkColors, item.hasFront, item.hasBack, item.color, art.primary || '', art.back || '', details]);
    }
    reprice(items) {
      const groups = new Map();
      items.forEach(item => {
        if (!Number.isInteger(this.price(item, item.quantity))) throw new Error();
        const key = this.groupKey(item);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(item);
      });
      const totals = new Map();
      for (const lines of groups.values()) {
        const quantity = lines.reduce((sum, item) => sum + item.quantity, 0);
        let running = 0, allocated = 0;
        for (const item of lines) {
          const combined = this.price(item, quantity);
          if (!Number.isInteger(combined)) throw new Error();
          running += combined * item.quantity / quantity;
          const rounded = Math.round(running);
          totals.set(item.key, rounded - allocated);
          allocated = rounded;
        }
      }
      return items.map(item => ({ ...item, lineCents: totals.get(item.key), unitCents: totals.get(item.key) / item.quantity }));
    }
    format(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency }).format(cents / 100); }
    node(tag, text, className) {
      const element = document.createElement(tag);
      if (text != null) element.textContent = text;
      if (className) element.className = className;
      return element;
    }
    render() {
      let custom = read();
      this.ready = false;
      if (this.loaded && !storageBlocked) {
        try { custom = this.reprice(custom); this.ready = true; this.error.textContent = ''; }
        catch { this.error.textContent = this.strings.update_error; }
      }
      this.items = [...custom, ...this.nativeItems];
      this.list.replaceChildren();
      this.querySelector('[data-order-empty]').hidden = Boolean(this.items.length);
      this.querySelector('[data-order-summary]').hidden = !this.items.length;
      this.querySelector('[data-order-form]').hidden = !this.items.length && !storageBlocked;
      this.form.querySelector('[type="submit"]').disabled = Boolean(this.submitting) || !this.ready || !this.items.length;
      for (const item of this.items) {
        const card = this.node('article', null, 'izz-order-card');
        const heading = this.node('h2', item.shirtType || item.productTitle);
        const description = [item.size, item.color, item.printSetup, item.method === 'screen' ? this.strings.screen : item.method === 'dtf' ? 'DTF' : item.method].filter(Boolean).join(' · ');
        card.append(heading, this.node('p', description, 'izz-small'));
        if (item.method === 'screen') card.append(this.node('p', `${this.strings.ink_colors}: ${item.inkColors}. ${this.strings.screen_included}`, 'izz-small'));
        if (item.sideEnabled) card.append(this.node('p', `${this.strings.side_design}: ${item.sideMethod} · ${this.strings.side_fee}`, 'izz-small'));
        for (const [side, url] of Object.entries(item.artwork || {})) {
          try {
            const address = new URL(url);
            if (!['https:', 'http:'].includes(address.protocol)) continue;
            const anchor = this.node('a', this.strings[side + '_artwork'], 'izz-artwork-download');
            anchor.href = address.href; anchor.target = '_blank'; anchor.rel = 'noopener'; card.append(anchor);
          } catch { }
        }
        const controls = this.node('div', null, 'izz-order-controls');
        const label = this.node('label', this.strings.quantity);
        const input = this.node('input'); input.type = 'number'; input.min = '1'; input.max = String(this.prices?.maxQuantity || 1200); input.step = '1'; input.value = String(item.quantity); input.setAttribute('aria-label', `${this.strings.quantity} — ${item.shirtType || item.productTitle}`);
        input.disabled = !this.loaded;
        const updateQuantity = async () => {
          if (!input.reportValidity()) return;
          const quantity = Number(input.value);
          try {
            if (item.native) {
              const response = await fetch(this.dataset.cartUrl + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.nativeKey, quantity }) });
              if (!response.ok) throw new Error(); await this.readNativeCart(); this.render();
            } else {
              const cents = this.price(item, quantity);
              if (cents == null) throw new Error();
              write(read().map(line => line.key === item.key ? { ...line, quantity, lineCents: cents, unitCents: cents / quantity } : line));
            }
          } catch { this.error.textContent = this.strings.update_error; }
        };
        input.addEventListener('change', updateQuantity);
        input.addEventListener('input', () => { this.form.querySelector('[type="submit"]').disabled = true; });
        const update = this.node('button', this.strings.update, 'izz-order-remove'); update.type = 'button'; update.disabled = !this.loaded; update.setAttribute('aria-label', `${this.strings.update} — ${item.shirtType || item.productTitle}`);
        update.addEventListener('click', updateQuantity);
        label.append(input);
        const remove = this.node('button', this.strings.remove, 'izz-order-remove'); remove.type = 'button'; remove.setAttribute('aria-label', `${this.strings.remove} — ${item.shirtType || item.productTitle}`);
        remove.addEventListener('click', async () => {
          try {
            if (item.native) {
              const response = await fetch(this.dataset.cartUrl + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.nativeKey, quantity: 0 }) });
              if (!response.ok) throw new Error(); await this.readNativeCart(); this.render();
            } else write(read().filter(line => line.key !== item.key));
          } catch { this.error.textContent = this.strings.update_error; }
        });
        if (!item.native && /^[a-z0-9-]+$/.test(item.handle || '')) {
          const edit = this.node('a', this.strings.edit, 'izz-button izz-button-outline');
          const address = new URL(this.dataset.rootUrl + 'products/' + item.handle, location.origin);
          address.searchParams.set('edit_item', item.key);
          edit.href = address.href;
          edit.setAttribute('aria-label', `${this.strings.edit} — ${item.shirtType || item.productTitle}`);
          controls.append(edit);
        }
        controls.append(label, update, this.node('strong', this.ready ? this.format(item.lineCents) : '—'), remove); card.append(controls); this.list.append(card);
      }
      const subtotal = this.items.reduce((sum, item) => sum + item.lineCents, 0);
      this.subtotal = subtotal; this.rushFee = this.querySelector('[data-production-speed]').value === 'rush5' ? Math.max(2500, Math.round(subtotal * 0.25)) : 0; this.tax = this.taxCents(subtotal + this.rushFee);
      this.querySelector('[data-order-rush]').textContent = this.ready ? this.format(this.rushFee) : '—';
      this.querySelector('[data-order-subtotal]').textContent = this.ready ? this.format(subtotal) : '—';
      this.querySelector('[data-order-tax]').textContent = this.ready ? this.format(this.tax) : '—';
      this.querySelector('[data-order-total]').textContent = this.ready ? this.format(subtotal + this.rushFee + this.tax) : '—';
      this.renderDelivery();
      this.buildRequest();
      if(storageBlocked)this.error.textContent=this.strings.storage_error;
    }
    taxCents(cents) {
      const rate = Math.round((this.prices?.shipping?.quoteTaxRate ?? 0.0875) * 1000000);
      return Math.floor((cents * rate + 500000) / 1000000);
    }
    buildRequest() {
      if (!this.ready) { this.querySelector('[data-order-body]').value = ''; return; }
      const lines = [this.strings.request_heading, 'Request reference: ' + (this.requestId || 'Assigned on submission'), 'Submitted: ' + (this.submittedAt || 'Pending'), 'Production: ' + (this.rushFee ? '5-business-day rush requested; availability must be confirmed' : 'Standard approximately 10 business days'), 'Production begins after payment and artwork approval. Pickup scheduled separately.', 'Cancellation: through second business day after submission (Pacific), ending earlier on acceptance and customer receipt of invoice. Final sale thereafter, except defective/incorrect/unfulfilled orders and legal remedies. Customer agreement required by submission form.', 'Fulfillment: Colton Post Office, 265 N 7th St, Colton, CA 92324', 'Payment: Confirm final price and artwork before sending one payment request'];
      this.items.forEach((item, index) => {
        lines.push('', `Item ${index + 1}: ${item.shirtType || item.productTitle}`, 'Quantity: ' + item.quantity, 'Size: ' + (item.size || ''), 'Color: ' + (item.color || ''), 'Decoration: ' + (item.method === 'screen' ? 'Screen printing' : item.method === 'dtf' ? 'DTF' : item.method), 'Print setup: ' + (item.printSetup || ''), 'Estimated item total: ' + this.format(item.lineCents));
        if (item.method === 'screen') lines.push('Ink colors: ' + item.inkColors, 'Screen burning charge: included in item estimate');
        if (item.sideEnabled) lines.push('Side decoration: ' + item.sideMethod, 'Side design fee: $5.00 per hat, included');
        for (const [side, url] of Object.entries(item.artwork || {})) if (url) lines.push(side + ' artwork download: ' + url);
        for (const [name, value] of Object.entries(item.properties || {})) if (value && !name.startsWith('_') && !/^(Artwork|Back artwork|Side artwork|Artwork link|Back artwork link|Side artwork link|Artwork permission|Front ink colors|Back ink colors|Fulfillment)$/i.test(name)) lines.push(name + ': ' + value);
      });
      lines.push('', 'Estimated apparel subtotal: ' + this.format(this.subtotal || 0), 'Estimated rush fee: ' + this.format(this.rushFee || 0), 'Meetup charge: $0.00', 'Estimated tax (Colton, 8.75%): ' + this.format(this.tax || 0), 'Estimated total: ' + this.format((this.subtotal || 0) + (this.rushFee || 0) + (this.tax || 0)), 'Meetup at Colton Post Office, 265 N 7th St, Colton, CA 92324. Tax: 8.75%.');
      if(this.deliveryMethod()==='shipping'){
        const e=this.deliveryEstimate, a=this.shippingAddress();
        const filtered=lines.filter(line=>!/^Fulfillment:|^Meetup charge:|^Estimated tax|^Estimated total:|^Meetup at/.test(line));
        filtered.push('Fulfillment: Ship to customer address', 'Recipient: '+a.firstName+' '+a.lastName, 'Address: '+[a.address1,a.address2,a.city,a.provinceCode,a.zip,a.countryCode].filter(Boolean).join(', '), 'Shipping: '+(e?.shippingPending?this.deliveryStrings.pending:e?this.format(e.shippingCents):this.deliveryStrings.needs_estimate), 'Estimated tax: '+(e?this.format(e.tax):'Pending'), (e?.shippingPending?'Estimated total before shipping: ':'Estimated total: ')+(e?this.format(e.total):'Pending'),this.deliveryStrings.estimate_note);
        this.querySelector('[data-order-body]').value=filtered.join('\n').replace('Pickup scheduled separately.','Shipping follows production.');
      }else this.querySelector('[data-order-body]').value = lines.join('\n');
    }
    pacificDate(value) {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(value));
      const get = type => parts.find(part => part.type === type).value;
      return `${get('year')}-${get('month')}-${get('day')}`;
    }
    cancellationDeadline(value) {
      const day = new Date(this.pacificDate(value) + 'T12:00:00Z');
      const holidays = new Set();
      const stamp = date => date.toISOString().slice(0, 10);
      const fixed = (year, month, date) => {
        const d = new Date(Date.UTC(year, month - 1, date, 12));
        if (d.getUTCDay() === 6) d.setUTCDate(d.getUTCDate() - 1);
        if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1);
        holidays.add(stamp(d));
      };
      for (let year = day.getUTCFullYear() - 1; year <= day.getUTCFullYear() + 1; year++) {
        [[1,1],[6,19],[7,4],[11,11],[12,25]].forEach(([m,d]) => fixed(year,m,d));
        [[1,1,3],[2,1,3],[9,1,1],[10,1,2],[11,4,4]].forEach(([m,w,n]) => {
          const d = new Date(Date.UTC(year,m-1,1,12));
          d.setUTCDate(1 + (w-d.getUTCDay()+7)%7 + (n-1)*7); holidays.add(stamp(d));
        });
        const memorial = new Date(Date.UTC(year,4,31,12));
        memorial.setUTCDate(31-(memorial.getUTCDay()+6)%7); holidays.add(stamp(memorial));
      }
      let counted = 0;
      while (counted < 2) {
        day.setUTCDate(day.getUTCDate()+1);
        if (![0,6].includes(day.getUTCDay()) && !holidays.has(stamp(day))) counted++;
      }
      return stamp(day);
    }
    renderReceipt() {
      const panel = this.querySelector('[data-order-receipt]');
      try {
        const receipt = JSON.parse(localStorage.getItem('izz_order_last_receipt_v1') || 'null');
        if (!receipt || typeof receipt.text !== 'string' || !receipt.submittedAt) return;
        const deadline = this.cancellationDeadline(receipt.submittedAt);
        const expired = this.pacificDate(Date.now()) > deadline;
        this.receiptId = receipt.id;
        let dismissed = this.receiptHidden === true;
        try { dismissed = localStorage.getItem('izz_order_receipt_hidden_v1') === receipt.id; } catch { }
        panel.hidden = dismissed;
        this.querySelector('[data-receipt-show]').hidden = !dismissed;
        panel.querySelector('[data-receipt-reference]').textContent = receipt.id;
        panel.querySelector('[data-receipt-text]').textContent = receipt.text;
        panel.querySelector('[data-receipt-deadline]').textContent = JSON.parse(this.querySelector('[data-policy-strings]').textContent) + deadline + ' at 11:59 p.m.';
        const download = panel.querySelector('[data-receipt-download]');
        if (this.receiptUrl) URL.revokeObjectURL(this.receiptUrl);
        this.receiptUrl = URL.createObjectURL(new Blob([receipt.text + '\nLatest cancellation deadline: ' + deadline + ' at 11:59 p.m. Pacific; closes earlier upon acceptance and receipt of invoice.'], { type: 'text/plain' }));
        download.href = this.receiptUrl; download.download = 'IzzRaw-order-request.txt';
        const cancel = panel.querySelector('[data-receipt-cancel]');
        cancel.hidden = expired;
        panel.querySelector('[data-receipt-help]').hidden = expired;
        panel.querySelector('[data-receipt-expired]').hidden = !expired;
        cancel.href = 'mailto:izzrawinks@gmail.com?subject=' + encodeURIComponent('Cancellation / refund review: ' + receipt.id) + '&body=' + encodeURIComponent('Please review my cancellation request.\nRequest: ' + receipt.id + '\nSubmitted: ' + receipt.submittedAt + '\nName and order email: \nInvoice number, if any: \nReason: \nI understand this request requires confirmation and does not automatically cancel or refund my order.');
      } catch { panel.hidden = true; }
    }
    disconnectedCallback() { if (this.receiptUrl) URL.revokeObjectURL(this.receiptUrl); document.removeEventListener('izz:order-cart', this.renderBound); window.removeEventListener('storage',this.storageBound); }
  }
  if (!customElements.get('izz-order-cart')) customElements.define('izz-order-cart', IzzOrderCart);
})();







